import { render, staticRenderFns } from "./MemoTagFilter.vue?vue&type=template&id=6a770130&scoped=true"
import script from "./MemoTagFilter.vue?vue&type=script&lang=ts"
export * from "./MemoTagFilter.vue?vue&type=script&lang=ts"
import style0 from "./MemoTagFilter.vue?vue&type=style&index=0&id=6a770130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a770130",
  null
  
)

export default component.exports